var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings",attrs:{"id":"usermanagement"}},[(!_vm.isAdmin)?_c('Userslist',{attrs:{"hartmann":false,"isInstitution":true}}):_c('div',[_vm._v(" Bitte verwalten Sie die Hartmann Benutzer über das DMS. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }